const eventList = [
    { title: "My time article", start: getDate("YEAR-MONTH-01") },
    {
      groupId: "999",
      title: "Medium article",
      start: getDate("YEAR-MONTH-09T16:00:00+00:00")
    },

  ];
  
  function getDate(dayString) {
    const today = new Date();
    const year = today.getFullYear().toString();
    let month = (today.getMonth() + 1).toString();
  
    if (month.length === 1) {
      month = "0" + month;
    }
  
    return dayString.replace("YEAR", year).replace("MONTH", month);
  }
  
  export {eventList};
  